import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-modal-changelog',
  templateUrl: './modal-changelog.component.html',
  styleUrls: ['./modal-changelog.component.scss']
})
export class ModalChangelogComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<ModalChangelogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit(): void {
  }

  close() {

    this.dialogRef.close();
  }

}
